import { RootState } from 'store';

export const settingsSelector = (state: RootState) => state.map_v2.map.settings;
export const contextMenuSelector = (state: RootState) =>
  state.map_v2.map.contextMenu;
export const toolsSelector = (state: RootState) => state.map_v2.map.tools;
